import fetch from '@/plugins/fetch'
import queryString from 'query-string'
import { PREFIX_KS_SORDER, PREFIX_SOPERATION_API } from '@/service'
const api = {
  orderListB: PREFIX_KS_SORDER + 'queryOrderListForLog.do',
  logListB: PREFIX_SOPERATION_API + 'business/worklog/queryList.do',
  logList: PREFIX_SOPERATION_API + 'worklog/queryList.do',
  configB: PREFIX_SOPERATION_API + 'business/worklog/queryItemsConfig.do',
  config: PREFIX_SOPERATION_API + 'worklog/queryItemsConfig.do',
  saveB: PREFIX_SOPERATION_API + 'business/worklog/save.do',
  queryDetailB: PREFIX_SOPERATION_API + 'business/worklog/queryDetail.do',
  queryDetail: PREFIX_SOPERATION_API + 'worklog/queryDetail.do'
}

export default {
  // 获取服务人员订单列表
  async fetchServiceOrderListB({ commit }, params) {
    try {
      const query = queryString.stringify(params)
      const res = await fetch(`${api.orderListB}?${query}`, {
        credentials: 'include'
      })
      const json = await res.json()
      if (json && json.data) {
        // TODO test
        const serviceOrderList = json.data.list || []
        // commit('setServiceOrderList', serviceOrderList)
        return serviceOrderList
      }
    } catch (e) {
      console.log(e)
    }
  },
  // B端获取日志列表
  async fetchServiceLogListB({ commit }, params) {
    try {
      const query = queryString.stringify(params)
      const res = await fetch(`${api.logListB}?${query}`, {
        credentials: 'include'
      })
      const json = await res.json()
      if (json && json.data) {
        // TODO test
        const serviceLogList = json.data || []
        // commit('setServiceLogList', serviceLogList)
        return serviceLogList
      }
    } catch (e) {
      console.log(e)
    }
  },
  // B端获取配置项
  async fetchServiceConfigB({ commit }) {
    try {
      const res = await fetch(`${api.configB}`, { credentials: 'include' })
      const json = await res.json()
      if (json && json.data) {
        const serviceConfigObj = json.data || {}
        commit('setServiceConfigObj', serviceConfigObj)
        return serviceConfigObj
      }
    } catch (e) {
      console.log(e)
    }
  },
  // B端更新保存入驻
  async fetchServiceLogSaveB({ commit }, params) {
    try {
      const query = queryString.stringify(params)
      const res = await fetch(`${api.saveB}`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST',
        body: `param=${encodeURIComponent(JSON.stringify(params))}`,
        credentials: 'include'
      })
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  // B端查询日志详情
  async fetchServiceQueryDetailB({ commit }, params) {
    try {
      const query = queryString.stringify(params)
      const res = await fetch(`${api.queryDetailB}?${query}`, {
        credentials: 'include'
      })
      const json = await res.json()
      if (json && json.data) {
        // TODO test
        const serviceLogDetail = json.data || {}
        commit('setServiceLogDetail', serviceLogDetail)
        return serviceLogDetail
      }
    } catch (e) {
      console.log(e)
    }
  },
  // C端获取日志列表
  async fetchServiceLogList({ commit }, params) {
    try {
      const query = queryString.stringify(params)
      const res = await fetch(`${api.logList}?${query}`)
      const json = await res.json()
      if (json && json.data) {
        // TODO test
        const serviceLogList = json.data || []
        // commit('setServiceLogList', serviceLogList)
        return serviceLogList
      }
    } catch (e) {
      console.log(e)
    }
  },
  // C端获取配置项
  async fetchServiceConfig({ commit }) {
    try {
      const res = await fetch(`${api.config}`)
      const json = await res.json()
      if (json && json.data) {
        const serviceConfigObj = json.data || {}
        commit('setServiceConfigObj', serviceConfigObj)
        return serviceConfigObj
      }
    } catch (e) {
      console.log(e)
    }
  },
  // C端查询日志详情
  async fetchServiceQueryDetail({ commit }, params) {
    try {
      const query = queryString.stringify(params)
      const res = await fetch(`${api.queryDetail}?${query}`)
      const json = await res.json()
      if (json && json.data) {
        // TODO test
        const serviceLogDetail = json.data || {}
        commit('setServiceLogDetail', serviceLogDetail)
        return serviceLogDetail
      }
    } catch (e) {
      console.log(e)
    }
  }
}
